<template>
  <v-container fluid class="pa-4">
    <v-breadcrumbs :items="breadcrumbs" class="px-0" />

    <div v-if="loading" class="pa-8 text-center"><v-progress-circular indeterminate /></div>
    <div v-else-if="!rubro" class="pa-8 text-center">
      <v-alert type="error">Rubro no encontrado</v-alert>
    </div>
    <div v-else>
      <div class="d-flex align-center mb-4">
        <h2 class="text-h5 font-weight-bold">{{ rubro.name }}</h2>
        <v-spacer />
        <v-btn color="primary" @click="openCreateSection">
          <v-icon left>mdi-plus</v-icon> Nueva sección
        </v-btn>
      </div>

      <v-card>
        <v-list>
          <v-list-item
              v-for="section in rubro.sections"
              :key="section._id"
              :to="`/sac/admin/config/section/${section._id}`"
              link
          >
              <v-list-item-avatar>
                  <v-icon color="primary">mdi-format-list-bulleted</v-icon>
              </v-list-item-avatar>
              <v-list-item-content>
                  <v-list-item-title class="font-weight-medium">
                      {{ section.name }}
                      <v-chip x-small class="ml-2">peso {{ section.weight }}</v-chip>
                      <v-chip v-if="section.isProfile" x-small color="grey" class="ml-1">Perfil</v-chip>
                  </v-list-item-title>
                  <v-list-item-subtitle>
                      {{ (section.questions || []).length }} preguntas
                  </v-list-item-subtitle>
              </v-list-item-content>
              <v-list-item-action>
                  <v-icon>mdi-chevron-right</v-icon>
              </v-list-item-action>
          </v-list-item>
        </v-list>
      </v-card>
    </div>

    <v-dialog v-model="dialog" max-width="500">
      <v-card>
        <v-card-title>Crear sección</v-card-title>
        <v-card-text>
          <v-text-field v-model="form.name" label="Nombre" outlined dense />
          <v-text-field v-model.number="form.weight" type="number" label="Peso (suma 100 en el rubro)" outlined dense class="mt-2" />
          <v-text-field v-model.number="form.order" type="number" label="Orden" outlined dense class="mt-2" />
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn text @click="dialog = false">Cancelar</v-btn>
          <v-btn color="primary" :loading="saving" @click="saveSection">Crear</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-alert type="error" v-if="error" class="mt-3" dismissible @input="error = null">{{ error }}</v-alert>
  </v-container>
</template>

<script>
import { mapMutations } from 'vuex';
import { listRubros, createSection } from '../../api/sac';

export default {
    name: 'SacConfigRubro',
    data() {
        return {
            loading: true,
            rubro: null,
            dialog: false,
            saving: false,
            error: null,
            form: { name: '', weight: 0, order: 0 },
        };
    },
    computed: {
        breadcrumbs() {
            return [
                { text: 'SAC Config', to: '/sac/admin/config', exact: true },
                { text: this.rubro?.name || '...' },
            ];
        },
    },
    mounted() {
        this.load();
    },
    methods: {
        ...mapMutations('notification', ['show']),
        async load() {
            this.loading = true;
            try {
                const r = await listRubros();
                this.rubro = (r.rubros || []).find((x) => x._id === this.$route.params.id) || null;
            } catch (e) {
                this.error = e?.response?.data?.error?.message || e?.response?.data?.message || e.message || 'No se pudo cargar el rubro';
                this.show({ text: this.error, color: 'error' });
            } finally {
                this.loading = false;
            }
        },
        openCreateSection() {
            this.form = { name: '', weight: 0, order: (this.rubro?.sections?.length || 0) };
            this.dialog = true;
        },
        async saveSection() {
            this.saving = true;
            try {
                await createSection({ ...this.form, rubro: this.rubro._id });
                this.dialog = false;
                await this.load();
                this.show({ text: 'Sección creada correctamente', color: 'success' });
            } catch (e) {
                this.error = e?.response?.data?.error?.message || e?.response?.data?.message || e.message || 'No se pudo crear la sección';
                this.show({ text: this.error, color: 'error' });
            } finally {
                this.saving = false;
            }
        },
    },
};
</script>
